import {
  Accordion,
  AccordionContent,
  AccordionItem,
  AccordionTrigger,
} from "@/components/ui/accordion";
import { Eyebrow, Reveal } from "../components/Reveal";

const FAQS = [
  {
    q: "O que é a Resolv?",
    a: "A Resolv é uma empresa de tecnologia e serviços que organiza, acompanha e resolve demandas de imóveis. Em vez de WhatsApp, telefone e planilhas soltas, cada solicitação vira um fluxo claro: análise, orçamento, execução e conclusão — tudo acompanhado do início ao fim.",
  },
  {
    q: "A Resolv atende pessoas físicas?",
    a: "Sim. Proprietários e inquilinos podem solicitar atendimento diretamente pelo site ou WhatsApp. Você conta o problema, e a Resolv organiza a solução.",
  },
  {
    q: "A Resolv atende imobiliárias?",
    a: "Sim — e é um dos nossos focos. Assumimos a operação de demandas dos imóveis gerenciados, com chamados centralizados, prestadores e acompanhamento, para que a equipe da imobiliária foque em clientes, locações e negócios.",
  },
  {
    q: "Como solicito um serviço?",
    a: "Clique em \"Solicitar atendimento\" aqui no site ou chame no WhatsApp. Descreva o que precisa ser resolvido e a nossa equipe inicia a análise em até 24h.",
  },
  {
    q: "Como acompanho minha solicitação?",
    a: "Cada demanda tem um fluxo de etapas visível: solicitação aberta, análise, profissional acionado, execução e resolvido. Você recebe atualizações em cada movimento — sem precisar ligar para saber como está.",
  },
  {
    q: "Como funciona o orçamento?",
    a: "Levantamos o que precisa ser feito, organizamos os custos e apresentamos com total transparência. Nenhum serviço é executado sem a sua aprovação ou a do responsável pelo imóvel.",
  },
  {
    q: "Como faço para ser um prestador parceiro?",
    a: "Preencha o cadastro na seção \"Seja parceiro\" com sua especialidade, documento e regiões atendidas. Nossa equipe analisa o perfil e entra em contato quando surgirem oportunidades na sua área.",
  },
  {
    q: "Em quais cidades a Resolv atende?",
    a: "Hoje atendemos Florianópolis, São José, Palhoça e a região da Grande Florianópolis (SC). Estamos em expansão constante — fale com a gente pelo WhatsApp ou formulário para confirmar a cobertura na sua cidade.",
  },
  {
    q: "A Resolv trabalha com imobiliárias e administradoras?",
    a: "Sim. Estruturamos operações personalizadas para imobiliárias e administradoras: fluxos de chamados, rede de prestadores, SLAs e relatórios desenhados para a sua carteira de imóveis.",
  },
];

export const Faq = () => (
  <section id="faq" className="relative py-24 lg:py-32" data-testid="faq-section">
    <div className="mx-auto max-w-3xl px-5 sm:px-8">
      <Reveal className="text-left">
        <Eyebrow>Dúvidas frequentes</Eyebrow>
        <h2 className="mt-4 font-display text-2xl font-bold tracking-tight text-petrol sm:text-3xl lg:text-4xl">
          Perguntas? <span className="text-brand">A gente resolve também.</span>
        </h2>
      </Reveal>

      <Reveal delay={0.15} className="mt-12">
        <Accordion type="single" collapsible className="space-y-3">
          {FAQS.map((item, i) => (
            <AccordionItem
              key={item.q}
              value={`faq-${i}`}
              data-testid={`faq-item-${i}`}
              className="rounded-2xl border border-slate-200/80 bg-white px-6 transition-colors duration-300 data-[state=open]:border-brand/40"
            >
              <AccordionTrigger
                data-testid={`faq-trigger-${i}`}
                className="py-5 text-left font-display text-base font-semibold text-petrol hover:text-brand hover:no-underline"
              >
                {item.q}
              </AccordionTrigger>
              <AccordionContent className="pb-5 text-sm leading-relaxed text-slate-600">
                {item.a}
              </AccordionContent>
            </AccordionItem>
          ))}
        </Accordion>
      </Reveal>
    </div>
  </section>
);
